import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../../../../assets/logo.png';
import { useAuth } from '../../../../contexts/AuthContext';

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword]       = useState('');
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState(null);
  const navigate  = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const result = await login(phoneNumber.trim(), password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="header-container">
        <div className="logo-container">
          <img src={Logo} alt="Fagi Errands" className="logo-img" />
          <span className="brand-name">Fagi Errands</span>
        </div>
        <div className="nav-links">
          <Link to="/signup" className="nav-link">Sign Up</Link>
          <Link to="/contact" className="contact-button">Contact Us</Link>
        </div>
      </div>

      <div className="form-wrapper">
        <h2>Login to Your Account</h2>

        {error && <div className="error-box">{error}</div>}

        <form onSubmit={handleLogin}>
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Phone Number (e.g. 0712345678)"
            required
            className="input-field"
          />

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            className="input-field"
          />

          <div className="row-between">
            <Link to="/forgot-password" className="link">Forgot password?</Link>
            <Link to="/signup" className="link">Create an account</Link>
          </div>

          <button type="submit" disabled={loading} className="primary-btn">
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>

      <style>{`
        .login-container {
          min-height: 100vh;
          background: radial-gradient(at center, #49AFAF, #A8DFF4);
          font-family: Arial, sans-serif;
        }
        .header-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 40px;
        }
        .logo-container { display: flex; align-items: center; gap: 10px; }
        .logo-img { width: 40px; height: 40px; object-fit: contain; }
        .brand-name { font-size: 20px; font-weight: bold; color: #111827; }
        .nav-links { display: flex; align-items: center; gap: 20px; }
        .nav-link { color: #111827; text-decoration: none; font-weight: 500; }
        .contact-button {
          background: #3b82f6; color: white; padding: 8px 20px;
          border-radius: 999px; text-decoration: none; font-weight: 500;
        }
        .form-wrapper {
          max-width: 460px; margin: 40px auto; padding: 0 20px; text-align: center;
        }
        h2 { font-size: 26px; font-weight: bold; color: #111827; margin-bottom: 24px; }
        .error-box {
          background: #fee2e2; border: 1px solid #f87171; color: #b91c1c;
          padding: 12px; border-radius: 6px; margin-bottom: 16px; font-size: 14px;
        }
        .input-field {
          width: 100%; padding: 12px 16px; margin-bottom: 14px;
          border: 1px solid #d1d5db; border-radius: 6px;
          font-size: 16px; background: white; box-sizing: border-box;
        }
        .input-field:focus { outline: none; border-color: #3b82f6; }
        .row-between {
          display: flex; justify-content: space-between;
          margin-bottom: 20px; font-size: 14px;
        }
        .link { color: #3b82f6; text-decoration: none; }
        .link:hover { text-decoration: underline; }
        .primary-btn {
          width: 100%; padding: 12px; background: #3b82f6; color: white;
          border: none; border-radius: 50px; font-size: 16px; font-weight: 500;
          cursor: pointer; transition: background 0.2s;
        }
        .primary-btn:hover { background: #2563eb; }
        .primary-btn:disabled { background: #9ca3af; cursor: not-allowed; }
      `}</style>
    </div>
  );
};

export default Login;
